import React from "react";
import "./HomeFeatureTab.css";
import { Container, Row, Col } from "react-bootstrap";
import SectionTitle from "../../../common/SectionTitle/SectionTitle";
import { useTranslation } from "react-i18next";

export default function HomeFeatureTab({
  imageSrc,
  titleKey,
  tabSubtitleKey,
  tabTitleKey,
  descriptionKey,
}) {
  const { t } = useTranslation();

  return (
    <div className="home-feature-tab">
      <Container fluid>
        <Row className="align-items-center">
          <Col md={6} lg={5}>
            <div className="home-feature-tab__media">
              <img
                src={imageSrc}
                alt={t(titleKey)}
                className="home-feature-tab__img"
              />
            </div>
          </Col>

          <Col md={6} lg={7}>
            <h3 className="home-feature-tab__title">{t(titleKey)}</h3>
            <p className="home-feature-tab__desc">{t(descriptionKey)}</p>

            <SectionTitle
              subtitle={t(tabSubtitleKey)}
              title={t(tabTitleKey)}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}